// extracted by mini-css-extract-plugin
export default {"introContainer":"createOmakasePlanIntro_introContainer__vb-jp","imageIcon":"createOmakasePlanIntro_imageIcon__LY4rQ","introText":"createOmakasePlanIntro_introText__HPrXg"};